import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CancelFeeEvent = BaseLoanEvent.extend({
  type: z.literal('cancelFee'),
  feeId: zodBrandedUuid<FeeId>(),
  comment: z.string().optional(),
});
export type CancelFeeEvent = z.infer<typeof CancelFeeEvent>;
